export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/banners.27766f4.svg";